<template lang="pug">
	.priority-container
		i.priority-icon.la(@click="incValue", :class="getClass(content)", v-b-tooltip.hover.right, :title="readonly ? 'Updated automatically' : 'Click to increment'")
</template>

<script>
export default {
  name: 'Priority',
  props: {
    value: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    value: function (newVal, oldVal) {
      // watch it
      this.content = newVal;
    },
  },
  data() {
    return {
      content: +this.value,
    };
  },
  methods: {
    incValue() {
      if (this.readonly) {
        return;
      }
      const min = Number.isFinite(+this.min) ? +this.min : 0;
      let next = this.content + 1;
      if (next > 7) {
        next = min;
      }
      this.content = next;
      this.$emit('input', this.content);
    },
    getClass(val) {
      let className = '';
      switch (val) {
        case 0:
          className = 'la-times';
          break;
        case 1:
          className = 'la-angle-double-down';
          break;
        case 2:
          className = 'la-angle-down';
          break;
        case 3:
          className = 'la-caret-down';
          break;
        case 4:
          className = 'la-minus';
          break;
        case 5:
          className = 'la-caret-up';
          break;
        case 6:
          className = 'la-angle-up';
          break;
        case 7:
          className = 'la-angle-double-up';
          break;

        default:
          className = '';
      }

      if (this.readonly) {
        className += ' readonly-mode';
      }
      return className ;
    },
  },
};
</script>

<style scoped lang="scss">
.priority-container {
  &:hover {
    cursor: pointer;
  }
}
.priority-icon {
  font-size: 22px;
  &.la-angle-double-up,
  &.la-angle-up,
  &.la-caret-up {
    color: #0e6b0e;
  }
  &.la-minus {
  }
  &.la-angle-down,
  &.la-angle-double-down,
  &.la-caret-down {
    color: #ff5252;
  }
  
  &.readonly-mode {
    cursor: default;
    opacity: 0.5;
  }
}
</style>
